import { ReactNode, useRef, useState } from 'react';
import { LFC } from '../../types';
import { ConfirmAlert } from '../AssignationModal/views';
import { ConfirmDialogContext } from './useConfirmDialog';

type PromiseRef = {
  resolve: (value?: void | PromiseLike<void>) => void;
  reject: (reason?: unknown) => void;
};

export const ConfirmDialogProvider: LFC = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [dialogBody, setDialogBody] = useState<ReactNode>();

  const ref = useRef<PromiseRef>(null);

  const handleOpen = (body: ReactNode) => {
    setOpen(true);
    setDialogBody(body);
    return new Promise<void>((resolve, reject) => {
      ref.current = { resolve, reject };
    });
  };

  const handleDecline = () => {
    setOpen(false);
    ref.current?.reject();
  };

  const handleConfirm = () => {
    setOpen(false);
    ref.current?.resolve();
  };

  return (
    <ConfirmDialogContext.Provider
      value={{ open: handleOpen, close: handleDecline }}
    >
      {children}
      <ConfirmAlert
        open={open}
        onConfirm={handleConfirm}
        onClose={handleDecline}
      >
        {dialogBody}
      </ConfirmAlert>
    </ConfirmDialogContext.Provider>
  );
};
